import { colors } from 'style/theme';

export const defaultTheme = (theme) => {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      primary: colors.silverGray, // selected option text
      neutral0: colors.white, // menu bg
      primary50: colors.galleryGray, // bg mousedown selected option,
      primary25: colors.galleryGray // bg hovered option
    }
  };
};

// ================== Dark variant ================== //

const darkStyles = (disabled) => ({
  container: (base) => ({
    ...base,
    paddingTop: '5px'
  }),
  input: () => ({
    height: '22px',
    color: colors.black,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.black
    };
  },
  control: (base) => ({
    ...base,
    borderRadius: 0,
    background: 'transparent',
    border: '0',
    borderBottom: disabled ? 'none' : `1px solid ${colors.black}`,
    opacity: disabled ? 0.7 : 1,
    boxShadow: '0',
    '&:hover': {
      border: '0',
      borderBottom: `1px solid ${colors.black}`
    },
    cursor: 'text',
    outline: 'none',
    minHeight: '22px',
    height: '22px',
    '> div': {
      // overflow: 'visible',
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px 10px',
    fontSize: '16px',
    color: colors.black
  })
});

// ================== Light variant ================== //

const lightStyles = {
  container: (base) => ({
    ...base,
    paddingTop: '5px'
  }),
  input: () => ({
    height: '22px',
    color: colors.white,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.white
    };
  },
  control: (base) => ({
    ...base,
    borderRadius: 0,
    background: 'transparent',
    border: '0',
    borderBottom: `1px solid ${colors.white}`,
    boxShadow: '0',
    '&:hover': {
      border: '0',
      borderBottom: `1px solid ${colors.white}`
    },
    cursor: 'text',
    outline: 'none',
    minHeight: '22px',
    height: '22px',
    '> div': {
      // overflow: 'visible',
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px 10px',
    fontSize: '16px',
    color: colors.black
  })
};

// ================== Block variant ================== //

const blockStyles = {
  container: (base) => ({
    ...base,
    paddingTop: '0px'
  }),
  input: () => ({
    height: '30px',
    color: colors.black,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '5px',
    display: 'flex',
    alignItems: 'center'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.black
    };
  },
  control: (base) => ({
    ...base,
    background: colors.white,
    borderRadius: '5px',
    border: `0`,
    boxShadow: '0',
    cursor: 'text',
    outline: 'none',
    minHeight: '29px',
    height: '29px',
    '> div': {
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px 10px',
    fontSize: '16px',
    color: colors.black
  })
};

// ================== Block-thick variant ============= //

const blockThickStyles = {
  ...blockStyles,
  control: (base) => ({
    ...base,
    background: colors.white,
    borderRadius: '5px',
    border: `0`,
    boxShadow: '0',
    cursor: 'text',
    outline: 'none',
    minHeight: '40px',
    height: '40px',
    '> div': {
      padding: '0px',
      margin: '0px'
    }
  })
};

// ================== Global variant ================== //

const globalStyles = {
  input: () => ({
    margin: 0,
    color: colors.white
  }),
  control: (base) => ({
    ...base,
    borderRadius: '4px',
    background: '#3D505C',
    border: '0.5px solid #5CC6C7',
    boxShadow: '0',
    outline: 'none',
    minHeight: '22px',
    '&:hover': {
      cursor: 'pointer'
    }
  }),
  option: (base) => ({
    ...base,
    background: colors.white,
    color: colors.black,
    '&:active': {
      background: colors.white
    },
    '&:hover': {
      cursor: 'pointer',
      color: colors.turquoise
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  })
};

// ================== Outline variant ================== //

const outlineStyles = {
  ...globalStyles,
  input: () => ({
    margin: 0,
    color: colors.black
  }),
  control: (base) => ({
    ...base,
    padding: '4px 8px',
    borderRadius: '4px',
    background: colors.dew,
    border: '1px solid #5CC6C7',
    boxShadow: '0',
    outline: 'none',
    minHeight: '22px',
    '&:hover': {
      cursor: 'pointer'
    },
    '> div': {
      padding: '2px 0'
    }
  })
};

// ================== Small variant ================== //

const smallStyles = {
  container: (base) => ({
    ...base,
    paddingTop: '0px'
  }),
  input: () => ({
    height: '16px',
    color: colors.white,
    padding: '0px',
    margin: '0px',
    fontSize: '14px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '14px',
      color: colors.white
    };
  },
  control: (base) => ({
    ...base,
    borderRadius: 0,
    background: 'transparent',
    border: '0',
    borderBottom: `1px solid ${colors.white}`,
    boxShadow: '0',
    '&:hover': {
      border: '0',
      borderBottom: `1px solid ${colors.white}`
    },
    cursor: 'text',
    outline: 'none',
    minHeight: '16px',
    height: '16px',
    '> div': {
      // overflow: 'visible',
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px',
    fontSize: '14px',
    color: colors.black
  }),
  menu: (base) => ({
    ...base,
    width: '125%'
  })
};

export const getSelectStyles = (variant, disabled) => {
  switch (variant) {
    case 'block-thick':
      return blockThickStyles;
    case 'block':
      return blockStyles;
    case 'light':
      return lightStyles;
    case 'global':
      return globalStyles;
    case 'small':
      return smallStyles;
    case 'outline':
      return outlineStyles;
    default:
      return darkStyles(disabled);
  }
};
